import { useTheme } from '@mui/material';
const useAssetsDetailStyles = () => {
    const theme = useTheme();
    const buttonStyles = {
        border: `1px solid ${theme.palette.divider}`
    };
    return {
        assetFormContainerStyles: {
            py: 3,
            px: 2,
            borderRadius: 1.5,
            border: `1px solid ${theme.palette.action.active}`,
            background: theme.palette.background.paper,
        },
        iconButtonStyles: {
            ...buttonStyles
        },
        saveButtonStyles: {
            borderRadius: '500px 0px 0px 500px',
            ...buttonStyles
        },
        discardButtonStyles: {
            borderRadius: '0 500px 500px 0',
            ...buttonStyles
        },
        leftSectionGridStyles: {
            scrollbarWidth: 'none' /* For Firefox */,
            '-ms-overflow-style': 'none' /* For Internet Explorer 10+ */
        }
    };
};
export default useAssetsDetailStyles;
